module.exports = __webpack_public_path__ + "img/happy-xmas.8396e1e8.jpeg";